/* This file was automatically generated by tools management permissions. It should not be changed manually. */
import {REG} from "/@lib@/commons/registry.js";
import "/@lib@/commons/basis_Perms.js";

const r = REG.reg;
r.newPerm("read.UTNode", "read", 0);
r.newPerm("write.UTNode", "write", 0);
r.newPerm("admin.UTNode", "admin", 0);
r.newPerm("view.depot", "read", 0);
r.newPerm("read.UTNode.webView", "read.UTNode", 0);
r.newPerm("preview.UTNode.evenIfTrashed", "write.UTNode", 0);
r.newPerm("write.UTNode.trash", "write.UTNode", 0);
r.newPerm("admin.UTNode.configRoles", "admin.UTNode", 0);
r.newPerm("admin.UTNode.configRoles.byAdmin", "admin.UTNode", 0);
r.newPerm("upload.UTNode.content", "write.UTNode", 0);
r.newPerm("edit.UTNode.metas", "write.UTNode", 0);
r.newPerm("write.UTNode.untrash", "write.UTNode", 0);
r.newPerm("write.UTNode.remove", "write.UTNode", 0);
r.newPerm("write.UTNode.unlist", "write.UTNode", 0);
r.newPerm("write.UTNode.relist", "write.UTNode", 0);
r.newPerm("upload.QueryUTNode", "admin.UTNode", 0);
r.newPerm("edit.UTNode.moveFrom", "edit.UTNode.metas", 0);
r.newPerm("edit.UTNode.rename", "edit.UTNode.metas", 0);
